import type { LucideIcon } from "lucide-react";

interface CountSummaryProps {
  label: string;
  count: number | string;
  icon: LucideIcon;
  /** What the number counts, when that is not obvious from the label alone. */
  hint?: string;
}

/** A compact metric card used above list views. */
export function CountSummary({
  label,
  count,
  icon: Icon,
  hint,
}: CountSummaryProps) {
  return (
    <div className="inline-flex min-h-18 w-full items-center gap-3 rounded-2xl border border-[rgb(var(--border))] bg-[rgb(var(--card))] px-4 py-3 shadow-lifted md:w-auto">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[rgb(var(--text-accent))]/10 text-[rgb(var(--text-accent))]">
        <Icon size={17} />
      </div>
      <span className="min-w-0">
        <span className="flex items-center gap-3">
          <span className="text-sm font-semibold text-[rgb(var(--text-primary))]">
            {label}
          </span>
          <span className="inline-flex min-w-7 justify-center rounded-full bg-[rgb(var(--accent-fill))] px-2 py-1 text-xs font-bold text-[rgb(var(--accent-ink))]">
            {count}
          </span>
        </span>
        {hint && (
          <span className="mt-0.5 block text-[11px] text-[rgb(var(--text-muted))]">
            {hint}
          </span>
        )}
      </span>
    </div>
  );
}
